import React from "react";
import PropTypes from "prop-types";
import _debounce from "lodash/debounce";
import _noop from "lodash/noop";
import { Select } from "antd";

const Option = Select.Option;

class ObjectSelect extends React.Component {
    dataSource = this.props.dataSource || [];
    debouncedSearch = _debounce(str => {
        this.props.onSearch(str).then(({ data }) => {
            if (data) {
                this.dataSource = data.results ? data.results : data;
                if(this.props.formatData) {
                    this.dataSource = this.props.formatData(this.dataSource);
                }
                this.forceUpdate();
            }
        });
    }, this.props.debounce);
    onFocus = async e => {
        // if(!this.dataSource || this.dataSource.length == 0) {
        this.loading = true;
        this.forceUpdate();
        this.props.getOptionsOnFocus().then(({ data }) => {
            if (data) {
                this.dataSource = data.results ? data.results : data;
                if(this.props.formatData) {
                    this.dataSource = this.props.formatData(this.dataSource);
                }
            }
            this.loading = false;
            this.forceUpdate();
        }).catch(() => {
            this.loading = false;
            this.forceUpdate();
        });
        if(this.props.getOptionsInApiResponse) {
            this.loading = true;
            const data = await this.props.getOptionsInApiResponse();
            if(data) {
                this.dataSource = data;
                if(this.props.formatData) {
                    this.dataSource = this.props.formatData(this.dataSource);
                }
                this.loading = false;
                this.forceUpdate();
            }
        }
        this.props.onFocus && this.props.onFocus(e);
        // }
    };
    onSearch = str =>
        this.props.showSearch ? this.debouncedSearch(str) : null;
    onSelect = value => {
        const { value: oldValue } = this.props;
        const option = this.dataSource.find(
            _ => (
                (this.props.labelProp.includes(".") ?
                    `${_[this.props.labelProp.split(".")[0]][this.props.labelProp.split(".")[1]]}`
                    : this.props.labelProp.includes("|") ?
                        `${_[this.props.labelProp.split("|")[0]]} | ${_[this.props.labelProp.split("|")[1]]}`
                        : _[this.props.labelProp]) === value
            )
        );
        if (this.props.mode && this.props.mode !== "default") {
            this.props.onChange(oldValue ? [...oldValue, option] : [option]);
            this.props.onSelect(oldValue ? [...oldValue, option] : [option]);
            // this.props.onCommit(oldValue ? [...oldValue, option] : [option]);
        } else {
            this.props.onChange(option);
            this.props.onSelect(option);
            // this.props.onCommit(option);
        }


    };
    onDeselect = value => {
        const { value: oldValue } = this.props;
        if (this.props.mode && this.props.mode !== "default") {
            this.props.onChange(
                oldValue.filter(_ => 
                    this.props.labelProp.includes("|") ? `${_[this.props.labelProp.split("|")[0]]} | ${_[this.props.labelProp.split("|")[1]]}` !== value : _[this.props.labelProp] !== value)
            );
            this.props.onDeselect(
                oldValue.filter(_ => _[this.props.labelProp] !== value)
            );
        } else {
            this.props.onChange(null);
            this.props.onDeselect(value);
        }
    };

    // onChange = (value) => {
    //     this.props.onChange(value);
    // }

    render() {
        const {
            placeholder,
            mode,
            disabled,
            showSearch,
            showArrow,
            loading,
            labelProp,
            className,
            value,
            filterOption,
            autoClearSearchValue,
            style,
            defaultValue
        } = this.props;
        if(!this.dataSource.length && this.props.dataSource && this.props.dataSource.length) {
            this.dataSource = this.props.dataSource;
        }
        const parentClass = this.props.parentClass || `object-select-parent-${Math.random()}`;
        return (
            <div className={parentClass}>
                <Select
                    defaultValue={defaultValue}
                    className={className}
                    placeholder={placeholder}
                    disabled={disabled}
                    mode={mode || "default"}
                    autoClearSearchValue={autoClearSearchValue}
                    dropdownMenuStyle={this.props.dropdownMenuStyle}
                    value={
                        value &&
                        (typeof value === "object" && value.length >= 0
                            ? value.map(_ => {
                                return _ && (labelProp.includes(".") ? _[labelProp.split(".")[0]][labelProp.split(".")[1]] : labelProp.includes("|") ? `${_[labelProp.split("|")[0]]} | ${_[labelProp.split("|")[1]]}` : _[labelProp]);
                            })
                            : (labelProp.includes(".") ? value[labelProp.split(".")[0]][labelProp.split(".")[1]] : value && labelProp.includes("|") ? `${value[labelProp.split("|")[0]]} | ${value[labelProp.split("|")[1]]}` : value && value[labelProp]))
                    }
                    filterOption={filterOption || true}
                    onSearch={this.onSearch || _noop}
                    onSelect={this.onSelect || _noop}
                    onChange={this.onChange || _noop}
                    onDeselect={this.onDeselect || _noop}
                    notFoundContent={this.props.notFoundContent}
                    onFocus={this.onFocus || _noop}
                    showSearch={showSearch || false}
                    showArrow={showArrow || false}
                    style={style || { minWidth: 200 }}
                    dropdownMatchSelectWidth={false}
                    loading={loading || this.loading || false}
                    getPopupContainer={() => document.getElementsByClassName(parentClass)[0]}
                    defaultOpen={this.props.open}
                >
                    {this.dataSource.map((_, index) => (
                        <Option
                            key={String(_.id) || (labelProp.includes(".") ? _[labelProp.split(".")[0]][labelProp.split(".")[1]] : labelProp.includes("|") ? `${_[labelProp.split("|")[0]]} | ${_[labelProp.split("|")[1]]}` : _[labelProp]) || index}
                            value={labelProp.includes(".") ? _[labelProp.split(".")[0]][labelProp.split(".")[1]] : labelProp.includes("|") ? `${_[labelProp.split("|")[0]]} | ${_[labelProp.split("|")[1]]}` : _[labelProp]}
                            index={index}
                            disabled={_.disabled || false}
                        >
                            {labelProp.includes(".") ? _[labelProp.split(".")[0]][labelProp.split(".")[1]] : labelProp.includes("|") ? `${_[labelProp.split("|")[0]]} | ${_[labelProp.split("|")[1]]}` : _[labelProp]}
                        </Option>
                    ))}
                </Select>
            </div>
        );
    }
}

ObjectSelect.defaultProps = {
    dataSource: [],
    onSearch: _noop,
    onSelect: _noop,
    onDeselect: _noop,
    onChange: _noop,
    debounce: 400,
    labelProp: "text",
    autoClearSearchValue: true,
    getOptionsOnFocus: () => Promise.resolve({}),
    getOptionsInApiResponse: null,
    formatData: null
};

ObjectSelect.propTypes = {
    open: PropTypes.bool,
    placeholder: PropTypes.string,
    mode: PropTypes.string,
    onSearch: PropTypes.func,
    onChange: PropTypes.func,
    onSelect: PropTypes.func,
    onDeselect: PropTypes.func,
    disabled: PropTypes.bool,
    showSearch: PropTypes.bool,
    showArrow: PropTypes.bool,
    loading: PropTypes.bool,
    debounce: PropTypes.number,
    labelProp: PropTypes.string,
    className: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    dataSource: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    filterOption: PropTypes.func,
    getOptionsOnFocus: PropTypes.func,
    dropdownMenuStyle: PropTypes.object,
    onFocus: PropTypes.func,
    onCommit: PropTypes.func,
    style: PropTypes.object,
    parentClass: PropTypes.string,
    popupContainer: PropTypes.object,
    autoClearSearchValue: PropTypes.bool,
    defaultValue: PropTypes.string,
    getOptionsInApiResponse: PropTypes.func,
    formatData: PropTypes.func,
    notFoundContent: PropTypes.string,
};

export default ObjectSelect;
